module.exports = __webpack_public_path__ + "assets/media/3.cedd1e13.wav";